import { AnalyticsConfigurations } from '@epicuro-next/constants/rule-engine/analytics-rules';
import { selectConfigurationValueFrom } from '@epicuro-next/platform/configuration';
import { selectIsSalesRepOrAdmin } from '@epicuro-next/state/user-state';
import { createSelector } from '@ngrx/store';

import {
  ANALYTICS_BASKET_INSIGHT_CONFIG,
  ANALYTICS_BASKET_INSIGHT_DEFAULT_SORTING_CONFIG,
} from '../constants';

import { selectAnalyticsState } from './analytics-base.selectors';

export const selectCanSeeBasketInsights = createSelector(
  selectIsSalesRepOrAdmin,
  selectConfigurationValueFrom<
    typeof ANALYTICS_BASKET_INSIGHT_CONFIG.featureName,
    AnalyticsConfigurations
  >(
    ANALYTICS_BASKET_INSIGHT_CONFIG.namespace,
    ANALYTICS_BASKET_INSIGHT_CONFIG.featureName,
    ANALYTICS_BASKET_INSIGHT_CONFIG.defaultValue,
  ),
  (isSalesRepOrAdmin, isListAnalyticsBasketInsightEnabled) =>
    !!(isSalesRepOrAdmin && isListAnalyticsBasketInsightEnabled),
);

export const selectBasketInsightsDefaultSorting = selectConfigurationValueFrom<
  typeof ANALYTICS_BASKET_INSIGHT_DEFAULT_SORTING_CONFIG.featureName,
  AnalyticsConfigurations
>(
  ANALYTICS_BASKET_INSIGHT_DEFAULT_SORTING_CONFIG.namespace,
  ANALYTICS_BASKET_INSIGHT_DEFAULT_SORTING_CONFIG.featureName,
  ANALYTICS_BASKET_INSIGHT_DEFAULT_SORTING_CONFIG.defaultValue,
);

export const selectListBasketInsightsLoading = createSelector(
  selectAnalyticsState,
  (state) => state.basketInsightsLoading,
);
